import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { SectionHeading } from "@/components/PageIntro";

function Counter({ to, suffix = "", duration = 1400 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start;
    let raf;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
}

const STATS = [
  { to: 100, suffix: " %", label: "Organisation", color: "#8B5CF6" },
  { to: 1, suffix: " App", label: "Für alles", color: "#00E5FF" },
  { to: 0, suffix: "", label: "Chaos beim Festival", color: "#22C55E" },
];

export default function WhyFestivalPlan() {
  return (
    <section id="why" data-testid="why-section" className="border-b border-white/10">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-5 py-20 lg:grid-cols-[1fr_1.2fr] lg:gap-20 lg:px-8 lg:py-24">
        <Reveal>
          <SectionHeading eyebrow="Warum FestivalPlan" title={<>Weniger Diskussion.<br />Mehr Festival.</>} />
          <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">
            FestivalPlan ersetzt WhatsApp-Gruppen, Excel-Listen und unübersichtliche Notizen –
            und bringt eure gesamte Crew auf denselben Stand.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <dl className="grid grid-cols-1 divide-y divide-white/10 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
            {STATS.map((s) => (
              <div key={s.label} className="py-6 sm:px-8 sm:py-2 sm:first:pl-0">
                <dd className="whitespace-nowrap font-display text-4xl font-bold tracking-tighter lg:text-5xl" style={{ color: s.color }}>
                  <Counter to={s.to} suffix={s.suffix} />
                </dd>
                <dt className="mt-2 text-sm text-white/55">{s.label}</dt>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  );
}
